/**
 * actr.ts - Actr (Action Orchestration) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1540 [pending] danielbeer: Initial creation
 */

export const actrModule = {
  id: 'system-actr',
  name: 'Action Orchestration',
  icon: '⚡',
  category: 'modules',
  order: 4,
  
  // Package metadata for info panel
  packageInfo: {
    name: '@opcentral/actr',
    version: '0.2.0+251021002750',
    displayVersion: '0.2.0',
    description: 'Universal action orchestration and CRUD operations for OpCentral',
    status: 'implemented',
    implementationProgress: 95,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/loggr': '*'
    },
    keywords: ['actions', 'orchestration', 'crud', 'middleware', 'operations'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    enableMiddleware: {
      type: 'boolean',
      label: 'Enable Middleware',
      description: 'Run middleware for all actions',
      defaultValue: true
    },
    
    enableLogging: {
      type: 'boolean',
      label: 'Action Logging',
      description: 'Log all action executions',
      defaultValue: true
    },
    
    enableCaching: {
      type: 'boolean',
      label: 'Result Caching',
      description: 'Cache action results when possible',
      defaultValue: true
    },
    
    cacheTimeout: {
      type: 'number',
      label: 'Cache Timeout (seconds)',
      description: 'How long to cache action results',
      defaultValue: 300,
      min: 10,
      max: 3600,
      visible: (settings) => settings['system-actr.enableCaching']
    },
    
    enablePermissionChecks: {
      type: 'boolean',
      label: 'Permission Checks',
      description: 'Verify permissions before executing actions',
      defaultValue: true
    },
    
    strictMode: {
      type: 'boolean',
      label: 'Strict Mode',
      description: 'Throw errors on validation failures',
      defaultValue: false
    }
  }
};

export default actrModule;
